import { useIsDesktop } from '@ps/web-shared-components';
import Loadable from 'react-loadable';

import { AcknowledgeNotificationMutation } from './gql/queries/notifications';
import { ExtendSelfExclusionMutation } from './gql/queries/selfExclusion';
import AccountInfoMessage from './src/AccountInfoMessage/AccountInfoMessage';
import AccountResolver from './src/AccountResolver/AccountResolver';
import AddressForm from './src/AddressForm/AddressForm';
import ChestInventory from './src/ChestInventory';
import ChestAwardMessage from './src/ChestInventory/components/ChestAwardMessage/ChestAwardMessage';
import ChestGrid from './src/ChestInventory/components/ChestGrid/ChestGrid';
import DeAnnualAttestationAddressForm from './src/DeAnnualAttestationAddressForm/DeAnnualAttestationAddressForm';
import { DeAddressFormType } from './src/DeAnnualAttestationAddressForm/useOnCompleteAttestation';
import PlayMoney from './src/Header/PlayMoney/PlayMoney';
import ForcedOccupation from './src/Occupation/ForcedOccupation/ForcedOccupation';
import Occupation from './src/Occupation/Occupation';
import { PEPHIOOptions } from './src/Occupation/PEPHIOSelection/PEPHIOSelection';
import CasinoSessionReminderForm from './src/ResponsibleGaming/CasinoSessionReminder/CasinoSessionReminderForm/CasinoSessionReminderForm';
import ExclusionResponse from './src/ResponsibleGaming/TakeABreakFromUs/ExclusionResponse/ExclusionResponse';
import ExclusionTitle, {
  getExclusionTitle
} from './src/ResponsibleGaming/TakeABreakFromUs/ExclusionTitle/ExclusionTitle';
import TakeABreakFromUsInformation from './src/ResponsibleGaming/TakeABreakFromUs/TakeABreakFromUsInformation/TakeABreakFromUsInformation';
import { ExclusionType } from './src/ResponsibleGaming/TakeABreakFromUs/definitions';
import useExclusionType from './src/ResponsibleGaming/TakeABreakFromUs/hooks/useExclusionType';
import Error from './src/ResponsibleGaming/shared/Error/Error';
import type { NetDepositLimitValues } from './src/ResponsibleGaming/shared/definitions';
import { ExclusionTime } from './src/ResponsibleGaming/shared/definitions';
import GQLClientSubscriptions from './src/ResponsibleGaming/shared/gql/components/GQLClientSubscriptions';
import WalletApolloProvider from './src/ResponsibleGaming/shared/gql/providers/WalletApolloProvider';
import GetUnreadNotificationsQuery from './src/ResponsibleGaming/shared/gql/queries/GetUnreadNotificationsQuery';
import useSelfExclusionData from './src/ResponsibleGaming/shared/hooks/useSelfExclusionData';
import SelfExclusionMessage from './src/SelfExclusionMessage/SelfExclusionMessage';
import StarsQuiz from './src/StarsQuiz/StarsQuiz';
import timezoneMap from './src/TimeZone/timezone-map.json';
import TournamentMoney, { TournamentMoneyBody } from './src/TournamentMoney/TournamentMoney';
import TournamentTickets, {
  TournamentTicketsBody
} from './src/TournamentTickets/TournamentTickets';
import View from './src/View/View';
import WrongPasswordMessage from './src/WrongPasswordMessage/WrongPasswordMessage';
import { default as PokerStarsIcon } from './src/assets/pokerstars-mobile-logo.svg';
import useMitId from './src/hooks/useMitId';
import styles from './src/styles/styles.scss';

export {
  AccountResolver,
  AccountInfoMessage,
  AddressForm,
  CasinoSessionReminderForm,
  ChestAwardMessage,
  ChestGrid,
  ChestInventory,
  DeAnnualAttestationAddressForm,
  DeAddressFormType,
  Error,
  ExclusionResponse,
  ExclusionTime,
  ExclusionTitle,
  ForcedOccupation,
  GQLClientSubscriptions,
  NetDepositLimitValues,
  Occupation,
  PEPHIOOptions,
  PlayMoney,
  SelfExclusionMessage,
  StarsQuiz,
  TournamentMoney,
  TournamentMoneyBody,
  TournamentTickets,
  TournamentTicketsBody,
  styles,
  TakeABreakFromUsInformation,
  timezoneMap,
  ExclusionType,
  getExclusionTitle,
  useIsDesktop,
  useMitId,
  GetUnreadNotificationsQuery,
  useSelfExclusionData,
  useExclusionType,
  View,
  WalletApolloProvider,
  WrongPasswordMessage,
  PokerStarsIcon,
  ExtendSelfExclusionMutation,
  AcknowledgeNotificationMutation
};

const StarsAccount = Loadable({
  loader: () => import(/* webpackChunkName: "StarsAccount" */ './src/Account/Account'),
  modules: ['./StarsAccount'],
  loading: () => null
});

export default StarsAccount;
